import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  AdminFeedbackTO, AdminPatchRequest, BugArea, FeedbackStatus, FeedbackType, Page,
} from 'features/feedback/shared/feedback.types';

export interface AdminFilters {
  type: FeedbackType | 'ALL';
  status: FeedbackStatus | 'ALL';
  area: BugArea | 'ALL';
}

interface Slice {
  items: AdminFeedbackTO[];
  filters: AdminFilters;
  selectedId: number | null;
  loading: boolean;
  saving: boolean;
  isAdmin: boolean | null;
}

const getInitialState = (): Slice => ({
  items: [],
  filters: { type: 'ALL', status: 'ALL', area: 'ALL' },
  selectedId: null,
  loading: false,
  saving: false,
  isAdmin: null,
});

const adminSlice = createSlice({
  name: 'admin',
  initialState: getInitialState(),
  reducers: {
    checkAccess: () => {},
    setAdmin: (s, { payload }: PayloadAction<boolean>) => {
      s.isAdmin = payload;
    },
    adminGet: (s) => {
      s.loading = true;
    },
    adminSet: (s, { payload }: PayloadAction<Page<AdminFeedbackTO>>) => {
      s.loading = false;
      s.items = payload.content;
    },
    adminError: (s) => {
      s.loading = false;
    },
    setFilter: (s, { payload }: PayloadAction<{ key: keyof AdminFilters; value: string }>) => {
      s.filters[payload.key] = payload.value as never;
    },
    select: (s, { payload }: PayloadAction<number>) => {
      s.selectedId = payload;
    },
    patch: (s, _action: PayloadAction<{ id: number; body: AdminPatchRequest }>) => {
      s.saving = true;
    },
    patchSuccess: (s, { payload }: PayloadAction<AdminFeedbackTO>) => {
      s.saving = false;
      const i = s.items.findIndex((it) => it.id === payload.id);
      if (i >= 0) s.items[i] = payload;
    },
    patchError: (s) => {
      s.saving = false;
    },
  },
});

export default adminSlice;
export const adminReducer = adminSlice.reducer;
export const adminActions = adminSlice.actions;
